import { useContext, useEffect, useMemo, useState } from 'react'
import { TextStyle } from '../../../../types'
import { ArtboardTextLayerProps } from '../../../artboard-gl/types'
import { DEFAULT_CAPTION_STYLE } from '../../constants'
import { UGEContext } from '../../context'
import LayerActions from '../shared/layer-actions'
import { AddCaption, Caption, Captions, TextStyler } from './style'

type Props = {
    className?: string
}

const UGECaptionsEditor = ({ className }: Props) => {
    const { activeEditorProps, layers, removeLayerById, resetEditorProps, updateLayerById } = useContext(UGEContext)
    const [activeCaptionId, setActiveCaptionId] = useState<string | undefined>()
    const captions = useMemo(() => layers.filter((layer) => layer.type === 'text'), [layers])

    function onRemove(layerId: string) {
        removeLayerById(layerId)
    }

    function onStyleChange(layerId: string, props: Partial<TextStyle>) {
        updateLayerById(layerId, props)
    }

    function onTextChange(layerId: string, text: string) {
        updateLayerById(layerId, { text })
    }

    useEffect(() => {
        setActiveCaptionId(activeEditorProps?.layerId)
        resetEditorProps()
    }, [activeEditorProps])

    return (
        <Captions className={className}>
            {captions.map((caption) => {
                const props = caption.props as ArtboardTextLayerProps
                const style = { ...DEFAULT_CAPTION_STYLE, ...props } as TextStyle

                return (
                    <Caption
                        layer={caption}
                        open={caption.id === activeCaptionId}
                        key={`uge-captions-editor-${caption.id}`}
                        onOpen={setActiveCaptionId}
                        onRemove={onRemove}
                        onTextChange={onTextChange}
                    >
                        <TextStyler textStyle={style} onChange={(props) => onStyleChange(caption.id, props)} />
                        <LayerActions editor="captions" layer={caption} />
                    </Caption>
                )
            })}
            <AddCaption
                placeholder={captions.length ? 'Add another caption...' : 'Add a caption'}
                onAdd={setActiveCaptionId}
            />
        </Captions>
    )
}

export default UGECaptionsEditor
